'use client';

import { getChain } from '#/lib/chains';
import invariant from 'invariant';

const chainId = process.env.NEXT_PUBLIC_CHAIN_ID;

/**
 * The Chain ID for the current environment.
 * @throws If the `NEXT_PUBLIC_CHAIN_ID` environment variable is not defined.
 */
export function useConfiguredChainId() {
  invariant(chainId != null, 'process.env.NEXT_PUBLIC_CHAIN_ID is not defined');
  return Number(chainId);
}
/**
 * The Chain object for the current environment.
 */
export function useConfiguredChain() {
  const chainId = useConfiguredChainId();
  return getChain(chainId)!;
}

/**
 * The default block explorer for the configured chain.
 */
export function useConfiguredBlockExplorer() {
  const chain = useConfiguredChain();
  return chain.blockExplorers?.default;
}
